import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./MeasurementsForm";
import {GET_PRODUCT_MEASUREMENTS} from "../../../queries/inventory";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {cancelChangeProductMeasurements} from "../../../actions/InventoryApiActions";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";
import {validateGreaterThan} from "../../../lib/Validators";
import {Map} from "immutable";

function validateForm(values) {
  let errors = Map();
  errors = validateGreaterThan(errors, values, "weight", 0);
  errors = validateGreaterThan(errors, values, "width", 0);
  errors = validateGreaterThan(errors, values, "height", 0);
  errors = validateGreaterThan(errors, values, "depth", 0);
  return errors.toJS();
}

class MeasurementsFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.changeProductMeasurements(values.toJS())
      .then((response) => {
        if (response.data.changeProductMeasurements.errors.length <= 0) {
          this.props.cancelChangeProductMeasurements();
        } else {
          let errors = createValidationErrors(response.data.changeProductMeasurements.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        console.warn(err);
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelChangeProductMeasurements();
  }

  render() {
    let {loading, error, product} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />
    let values = {
      sku: product.sku,
      weight: product.weight,
      width: product.width,
      height: product.height,
      depth: product.depth
    }

    return (
      <Form
        initialValues={values}
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const CHANGE_PRODUCT_MEASUREMENTS = gql`
  mutation changeProductMeasurements($data: ProductMeasurementsInput!) {
    changeProductMeasurements(input: $data) {
      errors { key message }
    }
  }
`;

const withProductQuery = compose(
  graphql(GET_PRODUCT_MEASUREMENTS, {
    options: (props) => ({
      variables: {
        sku: props.sku
      },
      cachePolicy: "network-only"
    })
  }),
  graphql(CHANGE_PRODUCT_MEASUREMENTS, {
    props: ({ mutate }) => ({
      changeProductMeasurements: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

const MeasurementsFormContainerWithData = withProductQuery(MeasurementsFormContainer);



export default connect(null, {cancelChangeProductMeasurements})(MeasurementsFormContainerWithData);